
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.405 6.532H3.902l-.901 15.239h15.597L17.405 6.532z","fill":"none","stroke":"#000","stroke-width":"1.8","transform":"matrix(1.07516 0 0 1.14201 .389 -1.988)"}}),_c('path',{attrs:{"d":"M7.878 2.253h8.131","fill":"none","stroke":"#000","stroke-width":"2.18","transform":"matrix(.83003 0 0 1 2.08 -1.16)"}}),_c('path',{attrs:{"d":"M8.618 1.093l-.614 6.216M15.368 1.093l.628 6.216","fill":"none","stroke":"#000","stroke-width":"2"}})])
          )
        }
      }
    